<template>
	<div class="items-list--item">
		<b-row align-v="center">
			<b-col :md="isListTypeCustomer ? 3 : 6">
				<div class="items-list--item-label">Job</div>
				{{ listItem.jobProfile.info }}
			</b-col>
			<b-col v-if="isListTypeCustomer" md="3">
				<div class="items-list--item-label">Person</div>
				{{ listItem.pseudonym.label }}
			</b-col>
			<b-col md="5">
				<div class="items-list--item-label">Verabschiedung</div>
				{{ listItem.initiator.label }} |
				{{ listItem.creationDate | weekdayShort }}, {{ listItem.creationDate | date }}
			</b-col>
			<b-col md="1" class="text-right">
				<a v-if="deletable" href="#" @click.prevent="remove = true">
					<Icon icon="bin" size="1comma5x" color="primary"/>
				</a>
			</b-col>
		</b-row>
		<ConfirmPopUp
			v-if="remove"
			title="Verabschiedung entfernen"
			:confirm-disabled="removing"
			:confirm-loading="removing"
			:closable="!removing"
			@confirm="removeSendOff"
			@hidden="remove = false"
		>
			Soll der Job wirklich wieder angezeigt werden?
		</ConfirmPopUp>
	</div>
</template>

<script>
import {LIST_TYPE_APPLICATION, LIST_TYPE_CUSTOMER} from "./List"
import Icon from "@/vue/icon/Icon.vue";
import ConfirmPopUp from "@/vue/common/popup/ConfirmPopUp.vue";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Remove from "@/api/sendoff/Remove";
import {APPLICANT, AUTO_APPLICANT, AUTO_CUSTOMER, AUTO_SYSTEM, CUSTOMER} from "@/helper/sendoff/Initiator";

export default {
	components: {ConfirmPopUp, Icon},

	props: {
		listItem: {
			type: Object,
			required: true,
		},
		listType: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			removing: false,
			remove: false,
		};
	},

	computed: {
		deletable ()
		{
			const initiatorId = this.listItem.initiator.id;

			if (this.listType === LIST_TYPE_CUSTOMER)
			{
				return [CUSTOMER, AUTO_CUSTOMER].includes(initiatorId);
			}

			if (this.listType === LIST_TYPE_APPLICATION)
			{
				return [APPLICANT, AUTO_APPLICANT].includes(initiatorId);
			}

			return initiatorId === AUTO_SYSTEM;
		},
		isListTypeCustomer ()
		{
			return this.listType === LIST_TYPE_CUSTOMER;
		}
	},

	methods: {
		async removeSendOff ()
		{
			this.removing = true;

			try
			{
				await new Remove()
					.setSendOffId(this.listItem.id)
					.call();

				this.remove = false;

				this.$emit('remove');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.removing = false;
		}
	}
}
</script>
